<template>
  <m-stories
    id="onboarding"
    :value="show"
    :start="controller?.story"
    :items="script||[]"
    :skipable="skipable||testing"
    @seen="seen"
    @close="(i) => toggle(false, i)"
  />
</template>

<style>
  #onboarding {
  }
</style>

<script>
  import services from '@/services'
  import { get } from 'vuex-pathify'

  export default {
    data: () => ({
      show: false,
      skipable: false,
      script: null,
      loading: false,
      controller: null
    }),
    computed: {
      user: get('user'),
      config: get('app/config'),

      completed () {
        const script = this.script || [];
        const completed = _.max(this.controller?.completed)==script.length-1 || this.onboarded;
        return script.length>0 && completed;
      },
      onboarded () {
        const profile = this.user.profile;
        const tags = profile?.tags||[];
        return tags.includes('onboarded');
      },
      testing () {
        const profile = this.user.profile;
        return (profile?.tags||[]).includes('onboarding');
      },
    },
    watch: {
      value (v) {
        if (v) {
          if (this.script) {
            this.toggle(v, 0);
          }else{
            this.load(false, null, null, [v, 0]);
          }
          this.skipable = true;
        }
      },
      completed: {
        immediate: true,
        handler (b) {
          if (b) {
            this.controller.seen = true;
            this.setStorage('onboard', this.controller);
            if (!this.testing&&!this.onboarded) {
              this.save();
            }
          }
        }
      },
      config (config) {
        if (config && this.script === null) {
          this.init();
        }
      },
    },
    methods: {
      ...services,

      init () {
        this.getStorage('onboard').then((value) => {
          this.controller = value && !this.testing ? value : {
            seen: false,
            story: 0,
            completed: []
          };
          if (!this.controller.seen) this.load();
        });
      },

      toggle (b=null, item=null) {
        const controller = this.controller;
        if (b===null) {
          const signedupAt = this.user.statusChange;
          const shouldShow = (!controller.seen&&this.$moment().diff(signedupAt, 'd')<=15)||this.testing;
          this.show = shouldShow;
          if (b) controller.story = _.max(controller.completed);
        }else{
          this.show = b;
          if (item!==null) {
            if (b) {
              controller.story = item;
            }else {
              this.seen(item);
            }
          }
          if (!b) this.$emit('close');
        }
        console.log('onboard', this.show, controller.story);
      },

      load (local, file, key, options=[]) {
        if (this.script||this.loading) return;
        console.log('load onboarding...', this.config);
        const content = this.getContent(this.user?.profile, this.config.onboarding.contents);
        if (content) {
          file = _.isNil(file) ? `/onboarding/${content}.json` : file;
          key = _.isNil(key) ? new Date().valueOf() : key;
          const url = (local ? `/onboarding/${content}.json` : this.getAppRoot()+file)+'?k='+key;
          this.loading = true;
          console.log('loading onboarding', local, url);
          fetch(url, { cache: 'no-store' }).then(r => r.json()).then((json) => {
            this.script = json;
            this.toggle(...options);
          }).catch((e) => {
            console.error('error loading onboarding', e);
            this.load(true);
          }).finally(() => {
            this.loading = false;
          });
        }
      },

      seen (i) {
        const controller = this.controller;
        controller.completed.push(i);
        this.$nextTick(() => {
          if (i+1<this.script.length) controller.story = i+1;
          this.setStorage('onboard', controller);
        });
      },

      save () {
        const token = this.user.auth.token;
        const cpf = this.rawData(this.user.cpf);
        this.$api.post('/updateprofilefield', {
          authTk: token,
          cpf: cpf,
          data: { tags: ['onboarded', ...this.user.profile.tags].join(',') }
        })
        .then(response => {
          console.log('updateProfile => ', response);
          if(response.data==200){
          }
        })
      }
    },

    mounted () {
      if (this.config) this.init();
    },

    props: {
      value: {
        type: Boolean,
        default: null
      }
    },

    components: {
      MStories: () => import('@/components/mStories')
    }
  }
</script>